import { useState } from "react";

import { useGetIdentity } from "@refinedev/core";

import type { IUser } from "@/types/types";

import { ConsentModal } from "./ConsentModal";

/**
 * ConsentOverlay checks if the authenticated user has accepted the
 * Terms & Conditions and Privacy Notice. If not, it renders a
 * non-dismissable modal that blocks the app until accepted.
 */
export const ConsentOverlay = () => {
  const { data: user, isLoading } = useGetIdentity<IUser>();
  const [dismissed, setDismissed] = useState(false);

  // Don't show while still loading identity
  if (isLoading || !user) {
    return null;
  }

  // Already accepted (from backend) or just accepted in this session
  if ((user.toc_completed && user.pn_completed) || dismissed) {
    return null;
  }

  return <ConsentModal open onAccepted={() => setDismissed(true)} />;
};
